import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlersReturn } from '../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3157ROLES } from '../../../U3157';
import type { U3157ImportModelFormRow } from '../../../U3157Service';

export type U3157ImportModelFormToolbarHandlers = U2000FormStateHandlersReturn<U3157ImportModelFormRow> & {
  addNewImportModel: () => void;
  modifyImportModel: () => void;
  deleteImportModel: () => void | Promise<void>;
};

interface U3157WorkNatureImportModelFormToolBarProps {
  formStateHandlers: U3157ImportModelFormToolbarHandlers;
}

export const U3157WorkNatureImportModelFormToolBar: React.FC<U3157WorkNatureImportModelFormToolBarProps> = ({
  formStateHandlers,
}) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3157ROLES.ADD),
      handleClick: () => formStateHandlers.addNewImportModel(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3157ROLES.EDIT),
      handleClick: () => formStateHandlers.modifyImportModel(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3157ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteImportModel(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
